'use strict';
var form = document.getElementById("form");
function handleForm(event) {
    event.preventDefault();
}
form.addEventListener('submit', handleForm);
document.querySelector('form').onsubmit = (e)=>{
    e.target.reset();
    return false;
};

//# sourceMappingURL=index.1a7ba9c5.js.map
